// Module
var code = `<div class="charge">
  <select class="charge-type"
          ng-model="\$ctrl.charge.type"
          ng-change="\$ctrl.charge.rate = 0"
          ng-options="o.value as o.label for o in \$ctrl.types"
          ng-disabled="\$ctrl.disableType"
          ng-required="true">
  </select>

  <cash ng-if="\$ctrl.charge.type == 'FIXED_AMOUNT'"
    ng-model="\$ctrl.charge.rate"
    ng-disabled="\$ctrl.disableRate"
    ng-required="true"></cash>
  <glue-container append-percentage="true" ng-if="\$ctrl.charge.type != 'FIXED_AMOUNT'">
    <input type="number"
           ng-model="\$ctrl.charge.rate"
           ng-required="true" min="0" step="0.00001"
           ng-disabled="\$ctrl.disableRate"
    />
  </glue-container>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/charge.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;